module.exports = __webpack_public_path__ + "img/answer-c2-4.85f3f54f.png";